<div id="deposit-details">
    <ms-slideshow
        size="large"
        [auto]="true"
        [delay]="8000"
        [circular]="true"
        [pageindicators]="true"
        [realtotalslidecount]="depositDetailsList.length">
        <ms-slide class="item details" *ngFor="let data of sitecore.betslip.depositDetailsList">
            <div id="introContent">
                <h1 [innerHTML]="data.headline"></h1>
                <img src="{{ data.image }}?p={{ imageSize }}" />
                <h2 [innerHTML]="data.subHeadline" [class]="{ empty: !data.subHeadline }"></h2>
                <div
                    class="description"
                    [class]="{ 'description-background': !!(data.headline && !data.subHeadline), 'empty': !data.description }"
                    [innerHTML]="html(data.description)"></div>
                <a *ngIf="data.link" [href]="getDepositDetailsLink(data.link)">
                    <button class="btn login" [innerHtml]="data.link"></button>
                </a>
            </div>
        </ms-slide>
    </ms-slideshow>
</div>
